// API Configuration
// Automatically detects the API server URL based on the current host
const getApiBaseUrl = () => {
  // In production, use relative URLs or set REACT_APP_API_URL
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production (Railway), API is on the same domain
  // In development, use localhost:5000
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // Production: use same domain (Railway serves both frontend and API)
  return '';
};

export const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;

